export default __webpack_public_path__ + "static/allergy-amulet-1-0c06d582ce010df3da4b4bbcde3ac62a.webp";